module.exports = __webpack_public_path__ + "static/media/phoneIconLight.20cf9927.svg";